<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import TaskKanbanColumn from './TaskKanbanColumn.vue';

const props = defineProps({
  tasks: { type: Array, required: true },
});

const emit = defineEmits(['status-change', 'edit-task', 'add-task']);

const { t } = useI18n();

const STATUSES = ['todo', 'in_progress', 'waiting_customer', 'done'];

const columns = ref({
  todo: [],
  in_progress: [],
  waiting_customer: [],
  done: [],
});

const syncColumns = () => {
  STATUSES.forEach(status => {
    columns.value[status] = props.tasks.filter(
      task => task.status === status
    );
  });
};

watch(() => props.tasks, syncColumns, { immediate: true, deep: false });

const columnTitles = {
  todo: t('CONTACTS_LAYOUT.SIDEBAR.TASKS.STATUS.TODO'),
  in_progress: t('CONTACTS_LAYOUT.SIDEBAR.TASKS.STATUS.IN_PROGRESS'),
  waiting_customer: t('CONTACTS_LAYOUT.SIDEBAR.TASKS.STATUS.WAITING_CUSTOMER'),
  done: t('CONTACTS_LAYOUT.SIDEBAR.TASKS.STATUS.DONE'),
};

// Mirrors TaskStatusSelect's STATUS_STYLES dots so a task's colour stays the
// same whether it's read from its pill or from the column it sits in.
const columnDots = {
  todo: 'bg-n-slate-9',
  in_progress: 'bg-n-blue-9',
  waiting_customer: 'bg-n-amber-9',
  done: 'bg-n-teal-9',
};

const onCardMovedIn = ({ taskId, status }) => {
  emit('status-change', { taskId, status });
};
</script>

<template>
  <!-- The board is a light canvas; the columns are transparent lanes on it
       and only the cards read as surfaces, as in the CrmB mockup. -->
  <div class="h-full overflow-auto bg-n-alpha-1 px-5 pt-4 pb-5">
    <div class="flex gap-4 min-h-full">
      <TaskKanbanColumn
        v-for="status in STATUSES"
        :key="status"
        :status="status"
        :title="columnTitles[status]"
        :dot="columnDots[status]"
        :model-value="columns[status]"
        @card-moved-in="onCardMovedIn"
        @edit-task="emit('edit-task', $event)"
        @add-task="emit('add-task', status)"
      />
    </div>
  </div>
</template>
